import { render } from "./CreateFinance.vue?vue&type=template&id=cdeb21b6"
import script from "./CreateFinance.vue?vue&type=script&lang=js"
export * from "./CreateFinance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__